var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errorMessage)?_c('p',{staticClass:"has-background-danger-dark has-text-white"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e(),_c('graph',{attrs:{"campusID":_vm.$store.state.campus.campusID,"cohort":_vm.$store.getters.currentCohort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }